import React, {  } from "react";
import "./MediaButton.css";

const MediaButton = ({
    children,
    disabled = false,
    pressed = false,
    onClick = () => {},
}) => {

    return (
        <button 
            disabled={disabled} 
            className={`mediabutton-container ${pressed ? "mediabutton-pressed" : ""}`} 
            onClick={onClick}>
            <div className="mediabutton-content">
                {children}
            </div>
            {/* pressed mask */}
            {pressed && <div className="mediabutton-pressed-mask" />}
        </button>
    )
}

export default MediaButton;